module.exports = __webpack_public_path__ + "static/media/Widget.cf202eed.png";